import { dashedBorders } from '@utils/styles'
import { twMerge } from '@lib/tailwind-merge'

interface SideCellProps {
  className?: string
  children?: React.ReactNode
  rowIndex: number
  highlight?: boolean
  showBorder?: boolean
}

export function SideCell({
  className,
  children,
  rowIndex,
  highlight,
  showBorder,
}: SideCellProps) {
  const style = {
    gridRowStart: rowIndex,
  }

  return (
    <div
      className={twMerge(
        'flex flex-row items-center',
        dashedBorders,
        highlight && 'bg-neutral-100',
        showBorder && 'first:border-t border-t',
        className,
      )}
      style={style}
    >
      {children}
    </div>
  )
}
